import { useState } from 'react';

export const useStepFlow = (steps) => {
  const [step, setStep] = useState(steps[0]);
  const index = steps.indexOf(step);
  const isLast = index === steps.length - 1;

  const goTo = (s) => steps.includes(s) && setStep(s);
  const previous = () => goTo(steps[index - 1]);
  const next = () => goTo(steps[index + 1]);
  const restart = () => setStep(steps[0]);

  return { step, next, restart, previous, isLast };
};
